/**
 * 应用中心满减活动模块
 */
export const ApplyFullReductionArr = [
  {
    path: "fullReduction/:id(\\d+)",
    name: "fullReduction",
    meta: {
      title: "满减活动"
    },
    redirect: "/apply/fullReduction/:id(\\d+)/frlist",
    component: () => import("@/views/sidebar/itemFrame.vue"),
    children: [
      {
        path: "frlist",
        name: "frlist",
        meta: {
          title: "满减活动管理"
        },
        component: () => import("@/views/apply/fullReduction/index.vue")
      },
      {
        path: "adActivity",
        name: "adActivity",
        meta: {
          title: "创建活动"
        },
        component: () => import("@/views/apply/fullReduction/adActivity.vue")
      }
    ]
  }
];
